import { SVGProps } from "react";

const ArticlesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_750_1563)">
        <path
          d="M0 10.0754L8.66339 15.0354L10.9141 12.2115L1.79174 7.39487L0 10.0754Z"
          fill="#43454E"
        />
        <path
          d="M13.0625 12.2015L15.3215 15.0359L24.0008 10.0667L22.1847 7.19971L13.0625 12.2015Z"
          fill="#43454E"
        />
        <path
          d="M3.10742 6.49984L11.9868 11.1882L20.8788 6.31266L12.0061 2.12158L3.10742 6.49984Z"
          fill="#43454E"
        />
        <path
          d="M2.26172 17.6635L11.2892 22.4301V13.9955L9.38592 16.3835C9.16992 16.6546 8.78864 16.7276 8.48782 16.5553L2.26172 12.9907V17.6635Z"
          fill="#43454E"
        />
        <path
          d="M12.6953 13.9936V22.4064L21.7228 17.4496V12.9888L15.4967 16.5534C15.1959 16.7255 14.8146 16.6526 14.5986 16.3816L12.6953 13.9936Z"
          fill="#43454E"
        />
      </g>
      <defs>
        <clipPath id="clip0_750_1563">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.275879)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArticlesIcon;
